export default __webpack_public_path__ + "static/media/footer-paypal.23de6718.png";